import React from 'react';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import AppLabels from '../../utils/appLabels';

const generalStyle = css`
  display: flex;
  flex-direction: column;
  min-width: 20rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  border-radius: 0.625rem;
  border: 0.0625rem solid #ddd9d5;
  background: #fff;
  padding: 1.125rem;

  @media (max-width: 641px) {
    min-width: initial;
    width: 100%;
    box-sizing: border-box;
  }
`;

const addressTypeStyle = css`
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.125rem;
  margin-bottom: 0.75rem;
`;

const addressDetailsStyle = css`
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
`;

const submitButtonStyle = css`
  margin: 1.5rem 2rem 0;
  cursor: pointer;
  font-size: 14px;
  line-height: 21px;
  border-radius: 100px;
  border: 1px solid #7b1a27;
  padding: 0.5rem 1rem;
`;

const unselectedButtonStyle = css`
  background: #fff;
  color: #7b1a27;
  border: 0.0625rem solid #7b1a27;
`;

const selectedButtonStyle = css`
  background: #f1f0ee;
  color: #535250;
  cursor: initial;
  border: none;
`;

const highlightedStyle = css`
  color: #fff;
  background-color: #7b1a27;
`;

const updateButtonContainerStyle = css`
  margin-top: 0.5rem;
  background: 0;
  border: 0;
  text-align: left;
  padding: 0;
  font-size: 1rem;
`;

const updateButtonStyle = css`
  color: #7b1a27;
  text-decoration: underline;
  margin-top: 0.5rem;
  cursor: pointer;
  font-weight: 600;
`;

/**
 * selected means the currently selected address from the backend
 * highlighted means it's just locally selected by the user, before saving any changes
 * @param address
 * @param selected
 * @param highlighted
 * @param onUseAddress
 * @param onUpdateAddress
 * @constructor
 */
const DeliveryAddressTile = ({ address, selected, highlighted, onUseAddress, onUpdateAddress }) => {
  const addressDetails = `${address.city}, ${address.state} ${address.zipCode}`;
  return (
    <div className={generalStyle}>
      <div className={addressTypeStyle}>{address.addressType.description}</div>
      <div className={addressDetailsStyle}>{address.address1}</div>
      <div className={addressDetailsStyle}>{addressDetails}</div>
      <button className={updateButtonContainerStyle} onClick={() => onUpdateAddress(address)}>
        <span role="button" className={updateButtonStyle}>
          {AppLabels.DeliveryTabForm.UpdateAddressButton}
        </span>
      </button>
      <input
        tabIndex={0}
        aria-label={
          selected
            ? `Selected address ${address.address1}, ${addressDetails}`
            : `Use address ${address.address1}, ${addressDetails}`
        }
        aria-roledescription="button"
        type="submit"
        value={selected || highlighted ? 'Selected' : 'Use address'}
        disabled={selected}
        className={`${submitButtonStyle} ${selected ? selectedButtonStyle : highlighted ? highlightedStyle : unselectedButtonStyle}`}
        onClick={() => onUseAddress(address)}
      />
    </div>
  );
};

DeliveryAddressTile.propTypes = {
  address: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  highlighted: PropTypes.bool,
  onUseAddress: PropTypes.func,
  onUpdateAddress: PropTypes.func,
};

export default DeliveryAddressTile;
